export default __webpack_public_path__ + "static/media/unionpay.0b1e26bd.svg";